import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { reduxForm } from 'redux-form';
import get from 'lodash.get';
import { Button, Form, Modal, Grid } from 'semantic-ui-react';

// Global Types
import { HarvestEvent } from 'services/harvestEvents/types';

// Global Actions
import { updateQueryString } from 'services/router/actions';

// Global Selectors
import { selectHarvestEventsArray } from 'services/harvestEvents/selectors';
import { selectHarvestSchemaId } from 'services/schemas/selectors';

// GlobalForm
// @ts-ignore
import { validators } from 'forms';

// Local Components
// @ts-ignore
import PickTypeTypeahead from '../../../PickTypeTypeahead';
// @ts-ignore
import SchemaEntityTypeahead from './components/SchemaEntityTypeahead';

// Constants
// @ts-ignore
import { FORM_NAME } from './constants';

// Validators
const { isRequired } = validators;

interface Props {
    harvestSchemaId?: number;
    updateQueryString: Function;
    onClose: Function;
    handleSubmit: Function;
    harvestEventsArray: HarvestEvent[];
}

class FindOrCreateSeasonalEventFormComponent extends React.PureComponent<Props> {
    handleSubmit = (values: Record<string, any>): void => {
        const { harvestEventsArray } = this.props;
        const harvestEvent = harvestEventsArray.find((value) => {
            const entityId = get(value, 'entityId');
            const pickTypeId = get(value, 'harvestEvent.pickTypeId');
            return (
                entityId === values.entityId &&
                pickTypeId === values.harvestEvent.pickTypeId
            );
        });
        if (harvestEvent) {
            this.props.updateQueryString({
                selectedEvent: harvestEvent.uuid
            });
        } else {
            this.props.updateQueryString({
                seasonalEventDefaultValues: values
            });
        }
    };

    render(): React.ReactElement {
        const { harvestSchemaId, handleSubmit, onClose } = this.props;

        return (
            <React.Fragment>
                <Modal.Header>Schedule Pick</Modal.Header>
                <Modal.Content>
                    <Form
                        onSubmit={handleSubmit(this.handleSubmit)}
                        autoComplete="off"
                    >
                        <React.Fragment>
                            <PickTypeTypeahead
                                name="harvestEvent.pickTypeId"
                                validate={isRequired}
                                label="Pick"
                                placeholder="Add Pick"
                            />
                            <SchemaEntityTypeahead
                                name="entityId"
                                validate={isRequired}
                                schemaId={harvestSchemaId}
                            />
                        </React.Fragment>
                        <Grid>
                            <Grid.Column width={8}>
                                <Button
                                    type="button"
                                    onClick={(): void => onClose()}
                                    basic
                                    primary
                                    fluid
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Button type="submit" primary fluid>
                                    Continue
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Form>
                </Modal.Content>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any, any>({
    harvestSchemaId: selectHarvestSchemaId,
    harvestEventsArray: selectHarvestEventsArray
});

export default connect(mapStateToProps, {
    updateQueryString
})(
    reduxForm<any, any>({
        form: FORM_NAME
    })(FindOrCreateSeasonalEventFormComponent)
);
